import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useRouteMatch } from 'react-router';
import SpeakingTestPartEditor from '../../../../components/cbt/speaking-test/part/Editor';
import ErrorResponse from '../../../../components/ErrorResponse';
import SimpleHeader from '../../../../components/layout/SimpleHeader';
import Loader from '../../../../components/Loader';
import useAxios from '../../../../hooks/useAxios';
import useNotification from '../../../../hooks/useNotification';
import {
  IGetSpeaking,
  IGetSpeakingPaper,
} from '../../../../models/newSpeaking.model';
import {
  getSpeaking,
  postSpeakingPaper,
} from '../../../../api/newSpeaking.api';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/rootReducer';
import { getDetailCode, getDetailCodeLabel } from '../../../../lib/util';

interface IMatch {
  id: string;
}

const CbtSpeakingTestPartCreate = () => {
  const { t } = useTranslation();
  const match = useRouteMatch<IMatch>();
  const speakingExamCode = String(match.params.id);
  const history = useHistory();

  const { successNotification } = useNotification();
  const {
    data: createRes,
    isLoading: createIsLoading,
    error: createError,
    execute: createExecute,
  } = useAxios<IGetSpeakingPaper>();
  const { data: res, isLoading, error, execute } = useAxios<IGetSpeaking>();
  const { commonCodes } = useSelector((state: RootState) => state.commonCode);

  const [title, setTitle] = useState('');

  const TE0008 = getDetailCode(commonCodes, 'TE0008');
  const TE0003 = getDetailCode(commonCodes, 'TE0003');
  const TE0002 = getDetailCode(commonCodes, 'TE0002');

  useEffect(() => {
    if (createRes && !createIsLoading) {
      successNotification(t('common.message.save1'));
      history.push(
        `/cbt/speaking-test/${speakingExamCode}/part/${createRes.data.speakingPartCode}/edit`,
      );
    }
  }, [createRes, createIsLoading]);

  useEffect(() => {
    speakingExamCode && execute(getSpeaking(speakingExamCode));
  }, [speakingExamCode]);

  useEffect(() => {
    if (res?.data) {
      setTitle(
        `${getDetailCodeLabel(
          TE0008,
          res.data.examType,
        )} / ${getDetailCodeLabel(TE0003, res.data.speakingExamType)}`,
      );
    }
  }, [res]);

  const onSubmit = (form: FormData) => {
    createExecute(postSpeakingPaper(form));
  };

  const getSpeakingPartCode = () => {
    let index = 0;
    const length = res?.data.papers.length;
    if (length !== undefined) {
      index = length;
    }
    return TE0002[index]?.detailCode;
  };

  return (
    <div className="content scrollbar">
      {(createIsLoading || isLoading) && <Loader />}
      <ErrorResponse error={createError} />
      <ErrorResponse error={error} />
      <SimpleHeader parentMenu={t('common.menu.cbt')} currentMenu={t('cbt.speakTest.title6')} onlyTitle />
      <div>
        <SpeakingTestPartEditor
          speakingPartCode={getSpeakingPartCode()}
          speakingExamCode={speakingExamCode}
          title={title}
          submit={onSubmit}
        />
      </div>
    </div>
  );
};

export default CbtSpeakingTestPartCreate;
